import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import closeIcon from '@/assets/icon/close-icon.svg';
import { cn } from '@/lib/utils';
import { Button } from '@/shared/components/ui/Button';
import type { ModalProfileManagementProps } from './ModalProfileManagement.types';
// import UpdatePassword from "@/components/Tab/ProfileManagement/UpdatePassword/UpdatePassword";
// import UpdateProfile from "@/components/Tab/ProfileManagement/UpdateProfile/UpdateProfile";
import UpdatePassword from './UpdatePassword/UpdatePassword';
import UpdateProfile from './UpdateProfile/UpdateProfile';

const ModalProfileManagement = ({
  isModalOpen,
  setIsModalOpen,
  userInfo,
  commonData,
}: ModalProfileManagementProps) => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState<'profile' | 'password'>('profile');

  const tabClass = cn(
    'flex flex-col items-center justify-center w-full h-[40px]',
    'relative text-center border-b border-[#6b7280]',
    'text-[#6b7280] dark:text-text-white'
  );
  const activeTabClass = 'font-bold';
  const devider = cn(
    'w-full h-[4px] top-[5px] rounded-[10px] relative',
    'bg-[#135A78] dark:bg-[#007AFF]'
  );

  return (
    <div className={cn('modal modal-background', isModalOpen && 'modal-open')}>
      <div className="modal-box">
        <div
          className={cn(
            'rounded-lg p-2.5',
            'bg-[#d0dee4] dark:bg-db-black dark:border-2 dark:border-[#2B465F]'
          )}
        >
          {/* Header */}
          <div
            className={cn(
              'h-[37px] flex items-center px-4 w-full justify-between rounded-t-md',
              'bg-[#135A78] dark:bg-db-black'
            )}
          >
            <span className="text-[16px] text-[#ffffff] font-bold">
              {t('profile > profile management')}
            </span>
            <div className="flex items-center gap-3">
              <Button
                variant="ghost"
                type="button"
                className="w-6 h-6 p-0 hover:bg-transparent cursor-pointer"
                onClick={() => setIsModalOpen(false)}
              >
                <img src={closeIcon} style={{ filter: 'invert(1)' }} alt="close" />
              </Button>
            </div>
          </div>

          {/* Body */}
          <div
            className={cn(
              'w-full p-5 shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] rounded-b-lg',
              'bg-white dark:bg-db-wrap'
            )}
          >
            {/* Tabs */}
            <div id="tab">
              <nav className="flex flex-row cursor-pointer">
                <button type="button" className={tabClass} onClick={() => setActiveTab('profile')}>
                  <span>
                    <li
                      className={cn(
                        'text-[20px] list-none',
                        activeTab === 'profile' ? activeTabClass : 'font-medium'
                      )}
                    >
                      {t('profile > profile')}
                    </li>
                  </span>
                  <div className={activeTab === 'profile' ? devider : ''} />
                </button>
                <button type="button" className={tabClass} onClick={() => setActiveTab('password')}>
                  <span>
                    <li
                      className={cn(
                        'text-[20px] list-none',
                        activeTab === 'password' ? activeTabClass : 'font-medium'
                      )}
                    >
                      {t('user > password')}
                    </li>
                  </span>
                  <div className={activeTab === 'password' ? devider : ''} />
                </button>
              </nav>

              {/* Tab Content */}
              <div className="tab-content">
                <div
                  className={cn(
                    'fade',
                    activeTab === 'profile' ? 'fade-enter-active' : 'fade-exit-active'
                  )}
                >
                  {activeTab === 'profile' && (
                    <UpdateProfile userInfo={userInfo} commonData={commonData} />
                  )}
                </div>
                <div
                  className={cn(
                    'fade',
                    activeTab === 'password' ? 'fade-enter-active' : 'fade-exit-active'
                  )}
                >
                  {activeTab === 'password' && <UpdatePassword userInfo={userInfo.account_id} />}
                </div>
              </div>
            </div>
          </div>
          {/* End Body */}
        </div>
      </div>
    </div>
  );
};

export default ModalProfileManagement;
